var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotmenuv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Menus/dot menu"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M7.74988 8.25008V7.75008M8.24988 8.25008V7.75008M7.74988 12.9167V12.4167M8.24988 12.9167V12.4167M7.74988 3.58342V3.08342M8.24988 3.58342V3.08342M7.99992 7.33325C8.36811 7.33325 8.66659 7.63173 8.66659 7.99992C8.66659 8.36811 8.36811 8.66659 7.99992 8.66659C7.63173 8.66659 7.33325 8.36811 7.33325 7.99992C7.33325 7.63173 7.63173 7.33325 7.99992 7.33325ZM7.99992 11.9999C8.36811 11.9999 8.66659 12.2984 8.66659 12.6666C8.66659 13.0348 8.36811 13.3333 7.99992 13.3333C7.63173 13.3333 7.33325 13.0348 7.33325 12.6666C7.33325 12.2984 7.63173 11.9999 7.99992 11.9999ZM7.99992 2.66659C8.36811 2.66659 8.66659 2.96506 8.66659 3.33325C8.66659 3.70144 8.36811 3.99992 7.99992 3.99992C7.63173 3.99992 7.33325 3.70144 7.33325 3.33325C7.33325 2.96506 7.63173 2.66659 7.99992 2.66659Z",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotmenuv);
export default __webpack_public_path__ + "static/media/dot menu v.a1409003c4315f39e91b1b23b289b1d2.svg";
export { ForwardRef as ReactComponent };